export const alphabetizer = {
  slug: "alphabetizer",
  categories: ["formatting"],
  heading: "Alphabetizer",
  description: "Arrange your list in any order you like.",
  btn: "Sort items",
};

export const assignmentCalculator = {
  slug: "assignment-calculator",
  categories: ["calculating"],
  heading: "Assignment calculator",
  description: "Use our assignment planner to manage your time and submit works in time.",
  order: 1,
  btn: "Plan assignment",
};

export const assignmentCalendar = {
  slug: "assignment-calendar",
  categories: ["calculating"],
  heading: "Assignment calendar",
  description: "Have your academic tasks planned out in advance..",
  order: 1,
  btn: "Plan assignment",
};

// export const websiteCitationGenerator = {
//   slug: "cite-a-website",
//   categories: ["formatting"],
//   heading: "APA website citation generator",
//   description: "PROVIDE!!!!!!!!!!!!!!!",
//   order: 1,
//   btn: "PROVIDE!!!!!!",
// };

export const caseConverter = {
  slug: "title-case-converter",
  categories: ["converting"],
  heading: "Case converter",
  description: "Transform your text case in a flash.",
  btn: "Convert case",
};

export const conclusionGenerator = {
  slug: "conclusion-generator",
  categories: ["summarizing"],
  heading: "Conclusion generator",
  description: "Paste your text and get a great conclusion that wraps up all key points in the paper.",
  order: 2,
  btn: "Create conclusion",
};

// export const essayMaker = {
//   slug: "essay-maker",
//   categories: ["content-generation", "writing"],
//   heading: "Essay maker",
//   description: "Leverage our intuitive essay generator to craft your paper instantly.",
//   btn: "Generate essay",
// };

// export const essayRewriter = {
//   slug: "essay-rewriter",
//   categories: ["content-generation", "writing"],
//   heading: "Essay rewriter tool",
//   description: "Get original essays rewritten in line with your needs.",
//   btn: "Rewrite essay",
// };

// export const essayTitleGenerator = {
//   slug: "essay-title-generator",
//   categories: ["content-generation"],
//   heading: "Essay title generator",
//   description: "Craft the perfect headline for your essay or academic paper in a click.",
//   btn: "Generate title",
// };

// export const essayTopicGenerator = {
//   slug: "essay-topic-generator",
//   categories: ["content-generation"],
//   heading: "Essay topic generator",
//   description: "Get multiple custom essay topics to choose from.",
//   btn: "Generate topics",
// };

// export const essayTyper = {
//   slug: "essay-typer",
//   categories: ["content-generation", "writing"],
//   heading: "Essay typer",
//   description: "Rely on our tool to have your essay typed within seconds.",
//   btn: "Type essay",
// };

export const gradeCalculator = {
  slug: "grade-calculator",
  categories: ["calculating"],
  heading: "Grade calculator",
  description: "Assess your current GPA and the grade you need to get on finals to nail your academic year.",
  btn: "Calculate grade",
};

export const grammarChecker = {
  slug: "grammar-checker",
  categories: ["paper-checker"],
  heading: "Grammar checker",
  description: "Polish your writing and eliminate errors with our Grammar checker.",
  btn: "Check grammar",
};

export const paperGrader = {
  slug: "paper-grader",
  categories: ["calculating"],
  heading: "Paper grader",
  description: "Check your writing for grammar mistakes and plagiarism – all in one tool.",
  btn: "Grade my paper",
};

// export const paraphrasingTool = {
//   slug: "paraphrasing-tool",
//   categories: ["writing"],
//   heading: "Paraphrasing tool",
//   description: "Have any text paraphrased in one click.",
//   btn: "Paraphrase",
// };

// export const plagiarismChecker = {
//   slug: "plagiarism-checker",
//   categories: ["paper-checker"],
//   heading: "Plagiarism checker",
//   description: "Instantly scan and ensure your work is 100% original.",
//   btn: "Check plagiarism",
// };

export const readabilityChecker = {
  slug: "readability-checker",
  categories: ["paper-checker"],
  heading: "Readability checker",
  description: "Assess and improve the clarity of your writing.",
  btn: "Check readability",
};

export const spellChecker = {
  slug: "spell-checker",
  categories: ["paper-checker"],
  heading: "Spell checker",
  description: "Ensure error-free writing with our precise Spell checker.",
  btn: "Check spelling",
};

// export const summarizer = {
//   slug: "summarizer-tool",
//   categories: ["summarizing"],
//   heading: "Summarizer",
//   description: "Condense your text to the essentials in seconds.",
//   btn: "Summarize",
// };

export const thesisStatementGenerator = {
  slug: "thesis-statement-generator",
  categories: ["content-generation"],
  heading: "Thesis statement generator",
  description: "Get a strong thesis statement for any type of academic paper in a matter of several minutes.",
  btn: "Crete thesis statement",
};

export const titlePageGenerator = {
  slug: "title-page-generator",
  categories: ["writing"],
  heading: "Title page generator",
  description:
    "Create a perfect title page formatted in line with the recent recommendations of APA, MLA or Chicago format.",
  btn: "Create title page",
};

export const wordCounter = {
  slug: "word-counter-tool",
  categories: ["calculating"],
  heading: "Word counter",
  description: "Track your text's length effortlessly with our word counting tool.",
  btn: "Count words",
};

export const wordsToMinutesConverter = {
  slug: "words-to-minutes-converter",
  categories: ["converting"],
  heading: "Words to minutes converter",
  description: "Transform your text into spoken time estimates instantly.",
  btn: "Convert words to minutes",
};

// export const writingPromptsGenerator = {
//   slug: "writing-prompt-generator",
//   categories: ["content-generation"],
//   heading: "Writing prompts generator",
//   description: "Spark endless inspiration for writing with a myriad of prompt suggestions.",
//   order: 4,
//   btn: "Generate prompts",
// };

export const wordsToPagesConverter = {
  slug: "words-to-pages-converter",
  categories: ["converting"],
  heading: "Words to pages converter",
  description:
    "Convert words to pages or vice versa. Perfect if you don’t know how many words one page should have.",
  order: 5,
  btn: "Convert word to pages",
};
